module.exports = __webpack_public_path__ + "static/media/SP_C_Embroidery_Bicocca_White_Bordeaux.479bd95f.png";